import {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {selectClassifiedCategory} from '~/common/fabric/reducers/eviteEvent/selectors';
import {FUNERAL_CATEGORY} from '~/common/utils/event_constants';
import {doesMatchEventCategory} from '~/common/utils/event_utils';
import {RsvpStatuses} from '~/ViewInvitation/common/RSVPModalVariantAB/types';
import {
  animationLength,
  ConfettiAnimation,
} from '~/ViewInvitation/routes/Confirmation/ConfettiAnimation/ConfettiAnimation';
import {selectIsFuneral} from '~/ViewInvitation/selectors/eviteEvent';

type SuccessRoktProps = {
  status: RsvpStatuses;
  play: boolean;
};

export const Animation = ({status, play}: SuccessRoktProps) => {
  const isFuneralType = useSelector(selectIsFuneral);
  const classifiedCategory = useSelector(selectClassifiedCategory);
  const isFuneral = isFuneralType || doesMatchEventCategory(classifiedCategory, FUNERAL_CATEGORY);
  const [animationPlaying, setAnimationPlaying] = useState(false);
  const [animationPlayed, setAnimationPlayed] = useState(false);

  const triggerAnimation = useCallback(() => {
    if (isFuneral || animationPlayed || !play) {
      return;
    }

    setAnimationPlaying(true);

    setTimeout(() => {
      setAnimationPlaying(false);
      setAnimationPlayed(true);
    }, animationLength);
  }, [isFuneral, animationPlayed, play]);

  useEffect(() => {
    if (status !== RsvpStatuses.No) {
      triggerAnimation();
    }
  }, [triggerAnimation, status]);

  return animationPlaying && <ConfettiAnimation height="100%" width="100%" />;
};
